import React from 'react';
import classNames from 'classnames';
import Modal from 'components/shared/modal';
import { Icon } from 'ui';

class BulkActionButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };
    this.handleClick = this.handleClick.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handleConfirm = this.handleConfirm.bind(this);
  }

  handleClick() {
    if (this.props.confirm) {
      this.setState({
        showModal: true,
      });
    } else {
      this.props.onClick();
    }
  }

  handleConfirm() {
    this.setState(
      {
        showModal: false,
      },
      () => {
        this.props.onClick();
      },
    );
  }

  closeModal() {
    this.setState({
      showModal: false,
    });
  }

  render() {
    const { props } = this;

    const styleNames = classNames('NewButton', {
      'NewButton--center': true,
      'NewButton--small': true,
      'IndexFilter-actionButton': true,
    });

    return (
      <>
        <button
          type="button"
          className={styleNames}
          onClick={this.handleClick}
          data-tooltip={props.tooltip}
        >
          <Icon name={props.iconName} />
          {props.label && (
            <span className="ml-8 c-brand-gray-darkest">{props.label}</span>
          )}
        </button>
        <Modal
          type="confirm"
          show={this.state.showModal}
          title={props.modalTitle}
          message={props.modalMessage}
          confirmButtonText={props.modalConfirmButton}
          cancelButtonText={props.modalCancelButton}
          onConfirm={this.handleConfirm}
          onCancel={this.closeModal}
          dismissCallback={this.closeModal}
        />
      </>
    );
  }
}

BulkActionButton.defaultProps = {
  confirm: true,
  modalConfirmButton: 'Yes',
  modalCancelButton: 'Cancel',
};

export default BulkActionButton;
